import { 
  FETCH_TITLE_DECORATIONS_REQUEST, 
  FETCH_TITLE_DECORATIONS_SUCCESS,
  FETCH_TITLE_DECORATIONS_FAILURE,
  CLEAR_TITLE_DECORATIONS,
} from '../actions/titleDecorations';

const defaultState = {
  loading: false,
  loaded: false,
  items: [],
};

export default function titleDecorations(state = defaultState, action) {
  switch (action.type) {
    case CLEAR_TITLE_DECORATIONS:
      return {
        ...state,
        defaultState
      };
    case FETCH_TITLE_DECORATIONS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_TITLE_DECORATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: [...action.payload.items],
        lastUpdated: action.payload.receivedAt,
      };
    case FETCH_TITLE_DECORATIONS_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}